module.exports = __webpack_public_path__ + "img/e9c83b08a2c29a8c40951f6922121a22.png";